import { useState, useEffect } from "react";
import { AgGridReact } from "ag-grid-react";
import Swal from "sweetalert2";
import httpService from "../../../../services/http.service";
import { useHistory } from "react-router-dom";
import { Button, Modal, ModalFooter, ModalHeader } from "reactstrap";
import SuccessMessage from "../../../common/successMsg";
import Select from "react-select";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "../../../../components/dashboard/dashboard.css";
import "bootstrap/dist/css/bootstrap.min.css";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import commonUtiles from "../../../common/commonUtiles";
import Loader from "../../../common/loader";
import WarningMessage from "../../../common/warnMsg";
import ErrorMessage from "../../../common/errorMsg";
import useUserSubscription from "../../../common/userSubcriptionHook";

const RuleDashboard = (props) => {
    const history = useHistory();
    const [allRuledata, setAllRuledata] = useState([]);
    const [save1, setSave1] = useState([]);
    const [IPFormatV, setIPFormatV] = useState([]);
    const [IPFormatVal, setIPFormatVal] = useState([]);
    const [onClickRuleData, setOnclickRuleData] = useState({});
    const [onClickData, setOnclickData] = useState({});
    const [IPFormatDataValue, setIPFormatDataValue] = useState([]);
    const [IPFormatData, setIPFormatData] = useState([]);
    const [selectedRuleValues, setSelectedRuleValues] = useState([]);
    const [defaultVal, setDefaultVal] = useState([]);
    const [show, setShow] = useState(false);
    const [selectedValue, setSelectedValue] = useState("");
    const [ipAddressPlaceHolder, setIpAddressPlaceHolder] = useState('255.255.255.0')
    const [onClickAddAndEditMsg, setOnClickAddAndEditMsg] = useState("Add");
    const [channels, setChannles] = useState();
    const [ipAddressNote, setIpAddressNote] = useState('')
    const [loading, setLoading] = useState(false);

    const { user, checkActiveStatus } = useUserSubscription()

    console.log("Default Value : ", defaultVal)

    const showLoader = () => {
        setLoading(true);
    }
    const hideLoader = () => {
        setLoading(false);

    }

    var rulearray = ["IpAddress", "MacAddress", "AccountNumber", "Geo_Location"];
    const ruleSelectValues = [
        { value: "IpAddress", label: "IP Address" },
        { value: "MacAddress", label: "Mac Address" },
        { value: "AccountNumber", label: "Account Number" },
        { value: "Geo_Location", label: "Geo Location(Long Lat)" },
    ];

    let gridOptions = {};
    let onGridReady = {};
    const columns = [
        {
            headerName: "Rule Name",
            field: "ChannelRulesName",
            sortable: "true",
            tooltipField: "ChannelRulesName",
        },
        {
            headerName: "Account Number",
            field: "RuleType.AccountNumber",
            tooltipField: "RuleType.AccountNumber",
        },
        {
            headerName: "Mac-Address",
            field: "RuleType.MacAddress",
            tooltipField: "RuleType.MacAddress",
        },
        {
            headerName: "Ip Address",
            field: "TableIp",
            tooltipField: "TableIp",
        },
        {
            headerName: "Geo-Location",
            field: "RuleType.Geo_Location",
            tooltipField: "RuleType.Geo_Location",
        },
        {
            headerName: "Edit ",
            field: "Edit",
            cellRenderer: (params) => {
                if (params.data.ChannelRulesName !== "Billing System") {
                    let span = document.createElement("button");
                    span.className = "btn btn-sm btn-secondary";
                    let img = document.createElement("i");
                    img.className = "edit icon me-0";
                    span.onclick = (event) => {
                        setOnClickAddAndEditMsg("Edit");
                        handleShow(event, params.data);
                    };
                    span.appendChild(img);
                    return span;
                }
            },
        },
        {
            headerName: "Delete",
            suppressMenu: true,
            suppressSorting: true,
            cellRenderer: (params) => {
                if (params.data.ChannelRulesName !== "Billing System") {
                    let span = document.createElement("button");
                    span.className = "btn btn-sm btn-danger";
                    let img = document.createElement("i");
                    img.className = "trash icon me-0";
                    img.onclick = (event) => {
                        DeleteConfirmationDialog(
                            "rule",
                            "Are you sure want to delete this rule?",
                            event,
                            params.data
                        );
                    };
                    span.appendChild(img);
                    return span;
                }
            },
            maxWidth: 100,
        },
    ];
    const defaultColDef = {
        sortable: false,
        editable: false,
        flex: 1,
        filter: false,
    };

    const DeleteRule = async (event, e) => {
        showLoader();
        let data = {
            id1: e._id,
        };
        const res = await httpService
            .CreateUpdate("DeleteRule", data)
            .catch((err) => {
                return;
            });

        // loadAlldata();
        if (res.data.message == "Successful") {
            SuccessMessage("Channel Rule Deleted Successfully");
            hideLoader();
        }
    };

    const handleShow = (e, item1) => {
        setSave1(false);
        let itemdata = allRuledata.filter((data) => {
            if (data._id == item1._id) {
                return data;
            }
        });
        let item = { ...itemdata[0] };
        if (item.RuleType.IpAddress) {
            let IPValidValue = Object.entries(item.RuleType.IpAddress);
            setIPFormatDataValue(IPValidValue);
            setIPFormatV(IPValidValue[0][0]);
            setIPFormatVal(IPValidValue[0][1]);
        }
        if (item.RuleType) {
            let selectedKeys = Object.keys(item.RuleType);
            let arr = [];
            for (let i = 0; i < selectedKeys.length; i++) {
                let obj = {
                    value: selectedKeys[i],
                    label: selectedKeys[i],
                };
                if (
                    selectedKeys[i] !== "Deviation" &&
                    selectedKeys[i] !== "Geo_Location_Original"
                ) {
                    let ChannelData = { ...onClickRuleData };
                    ChannelData[selectedKeys[i]] = item.RuleType[selectedKeys[i]];
                    setOnclickData(ChannelData);
                    arr.push(obj);
                }
            }
            setSelectedRuleValues(arr);
            console.log("Set Selected Rule Values : ", arr)
            setDefaultVal(arr);
        }

        setOnclickRuleData(item);
        if (!item.RuleType) {
            let ChannelData = { ...item };
            ChannelData["RuleType"] = {};
            setOnclickRuleData(ChannelData);
        }

        setShow(true);
    };

    const handleClose = () => {
        setShow(false);
        setSelectedRuleValues([]);
        setDefaultVal([]);
        setIPFormatV([]);
        setIPFormatVal([]);
        // loadProperty()
    };

    const handleRuleSelect = (selectedValue) => {
        // const hasGeoLocation = selectedValue.includes("Geo_Location");

        const selectedValues = selectedValue.map(obj => obj.value);
        console.log("Selected Value 2 : ", selectedValues)
        const hasGeoLocation = selectedValues.includes("Geo_Location");


        if (selectedValues.includes("AccountNumber")) {
            let ChannelData = { ...onClickRuleData };
            ChannelData.RuleType["AccountNumber"] = commonUtiles.generateAccountNumber();
            setOnclickRuleData(ChannelData);
        }


        if (hasGeoLocation && selectedValue.length > 2) {
            WarningMessage("Please select only valid two factor combination")
            return

        }
        console.log(hasGeoLocation, "hasGeoLocation", selectedValue)
        if (!hasGeoLocation && selectedValue.length > 1) {
            WarningMessage("Please select only valid two factor combination", `${hasGeoLocation}`)
            return
        }
        setSelectedRuleValues(selectedValue);
        console.log(selectedValue, "selectedValue")
        // if(selectedValue.length>1){
        // if(selectedValue[selectedValue.length-1].value=="AccountNumber"&&selectedValue[selectedValue.length-1].value=="AccountNumber"||selectedValue[selectedValue.length-1].value=="IpAddress"){
        //     console.log(selectedValue[selectedValue.length-1],"selectedValue")
        // }}
        let dataArrr = [];
        for (let j = 0; j < selectedValue.length; j++) {
            dataArrr.push(selectedValue[j]);
        }
        for (let i = 0; i < 4; i++) {
            // debugger
            if (onClickRuleData.RuleType && onClickRuleData.RuleType[rulearray[i]]) {
                let flag = true;
                for (let j = 0; j < selectedValue.length; j++) {
                    if (selectedValue[j].value === rulearray[i]) {
                        flag = false;
                    }
                }
                if (flag) {
                    let checkKey = Object.keys(onClickRuleData.RuleType)
                    if (checkKey[0] == "IpAddress") {
                        setIPFormatV('')
                    }
                    delete onClickRuleData.RuleType[rulearray[i]];
                }
            }
        }
        setDefaultVal(dataArrr);
        console.log("Set Data array : ", dataArrr)
    };

    const DeleteConfirmationDialog = async (msg, titileMsg, event, item) => {
        Swal.fire({
            title: titileMsg,
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            cancelButtonText: "No",
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes",
        }).then((result) => {
            if (result.isConfirmed) {
                DeleteRule(event, item);
            }
            //   if (result.isConfirmed) {
            //     if (msg === "property") {
            //       DeleteProperty(event, item)
            //     } else if (msg === "rule") {
            //       DeleteRule(event, item)
            //     } else if (msg === "Channel") {
            //       DeleteChannelRow(event, item);
            //     }
            //     else if (msg === "billboard") {
            //       Deletebillboarddata(event, item)
            //     }
            //   }
        });
    };

    useEffect(() => {
        if (!props.verifyTokenUser && history.location.pathname != "/login")
            history.push("/login");
    }, [props.verifyTokenUser]);

    const getRules = async () => {
        const UserIdData = localStorage.getItem("UserId");
        let reqAllData = {
            UserId: UserIdData,
        };
        let res = await httpService
            .CreateUpdate("getallrulebyuser", { reqAllData })
            .then((res) => res.data)
            .catch((err) => null);
        if (res) {
            console.log(res, "alldataapi?.data?.channelRuledata1");
            setAllRuledata(res?.data);
            console.log(res);
        }
    };

    useEffect(() => {
        if (props.props != "" && loading == false) {
            getRules();
        }
    }, [props.props, loading]);

    const saveChannelRule = async () => {
        // Check if onClickData and onClickData.RuleType are defined
        if (onClickRuleData && onClickRuleData.RuleType) {
            const ruleTypeKeys = Object.keys(onClickRuleData.RuleType);
            let ruleTypeKeysLength = ruleTypeKeys.length;
            if (ruleTypeKeys.includes("Geo_Location")) {
                ruleTypeKeysLength = ruleTypeKeysLength - 1
            }
            console.log(ruleTypeKeysLength, "ruleTypeKeysLength", onClickRuleData.RuleType)
            if (selectedRuleValues.length !== ruleTypeKeysLength) {
                WarningMessage("Please enter a value")
                return
            }
        }
        let validInput = await commonUtiles.validateRule(onClickRuleData);
        if (!validInput) { return }
        showLoader();
        let UserId = `${localStorage.getItem("UserId")}`;
        let data = {
            userId: UserId,
            user: onClickRuleData
        };
        if (selectedRuleValues.length > 2) {
            hideLoader();
            WarningMessage("Please create a rule with two factor or single factor.")
            return false;
        }


        if (onClickRuleData.RuleType && onClickRuleData.RuleType.Geo_Location && onClickRuleData.RuleType.Geo_Location.trim().split(" ").length !== 2) {
            hideLoader();
            WarningMessage("Enter Geo Location in proper format")
            return;
        } else if (onClickRuleData.RuleType && onClickRuleData.RuleType.Geo_Location && onClickRuleData.RuleType.Geo_Location.trim().split(" ").length === 2) {
            onClickRuleData.RuleType["Geo_Location_Original"] = {
                longitude_Maxm: parseFloat(onClickRuleData.RuleType.Geo_Location.split(" ")[1]) + parseFloat(onClickRuleData.RuleType.Deviation ? parseFloat(onClickRuleData.RuleType.Deviation) * 0.0166667 : 0.0333333),
                longitude_Minm: parseFloat(onClickRuleData.RuleType.Geo_Location.split(" ")[1]) - parseFloat(onClickRuleData.RuleType.Deviation ? parseFloat(onClickRuleData.RuleType.Deviation) * 0.0166667 : 0.0333333),
                latitude_Minm: parseFloat(onClickRuleData.RuleType.Geo_Location.split(" ")[0]) - parseFloat(onClickRuleData.RuleType.Deviation ? parseFloat(onClickRuleData.RuleType.Deviation) * 0.0166667 : 0.0333333),
                latitude_Maxm: parseFloat(onClickRuleData.RuleType.Geo_Location.split(" ")[0]) + parseFloat(onClickRuleData.RuleType.Deviation ? parseFloat(onClickRuleData.RuleType.Deviation) * 0.0166667 : 0.0333333),
            }
        }
        const res = await httpService
            .CreateUpdate("SaveChannelRule", data)
            .catch((err) => {
                return;
            });
        if (res.data.ack === "2") {
            hideLoader();
            ErrorMessage(res.data.message);
            return;
        } else if (res.data.ack === "3") {
            hideLoader();
            WarningMessage(res.data.message)
            return;
        } else if (res.data.message1 && res.data.message1 === "Account number matched") {
            hideLoader();
            WarningMessage("Account number matched")
        } else {
            SuccessMessage("Channel rule created successfully")
        }
        setSelectedRuleValues([]);
        setDefaultVal([]);
        // loadProperty();
        // loadAlldata();
        setShow(false);
        setIPFormatV([]);
        setIPFormatVal([]);
        hideLoader();
    };

    const handlec2 = (e) => {

        if (e.target.name === "MacAddress") {
            if (commonUtiles.MacValidation(e.target.value)) return;
            let ChannelData = { ...onClickRuleData };
            ChannelData.RuleType["MacAddress"] = e.target.value.toUpperCase();
            setOnclickRuleData(ChannelData);
        }
        if (e.target.name === "AccountNumber") {
            let ChannelData = { ...onClickRuleData }
            ChannelData.RuleType["AccountNumber"] = e.target.value;
            setOnclickRuleData(ChannelData);
        }
        if (e.target.name === "Geo_Location") {
            let ChannelData = { ...onClickRuleData };
            if (e.target.value.match(/[^0-9. -]/) || e.target.value.split(' ').length > 2 ||
                e.target.value.split(' ')[0].length != 1 && isNaN(e.target.value.split(' ')[0]) ||
                (e.target.value.split(' ').length === 2 && (e.target.value.split(' ')[0].length != 1 &&
                    isNaN(e.target.value.split(' ')[0]) || e.target.value.split(' ')[1].length != 1 && isNaN(e.target.value.split(' ')[1])))
            ) {
                return
            }
            ChannelData.RuleType["Geo_Location"] = e.target.value;
            setOnclickRuleData(ChannelData);
        }
        if (e.target.name === "Deviation") {
            let ChannelData = { ...onClickRuleData };
            ChannelData.RuleType["Deviation"] = e.target.value;
            setOnclickRuleData(ChannelData);
        }
    };

    const UpdateChannelrule = async () => {
        let validInput = commonUtiles.validateRule(onClickRuleData);
        if (!validInput) { return }
        showLoader();
        let UserId = `${localStorage.getItem("UserId")}`;
        let data = {
            userId: UserId,
            user: onClickRuleData,
        };
        let data1 = data.user.ChannelRulesName.trim()
            .split("  ")
            .filter((word) => word !== "");
        data.user.ChannelRulesName = data1.join(" ");
        if (selectedRuleValues.length > 2) {
            hideLoader();
            WarningMessage("Please create a rule with two factor or single factor.")
            return false;
        }

        if (onClickRuleData.RuleType && onClickRuleData.RuleType.Geo_Location && onClickRuleData.RuleType.Geo_Location.trim().split(" ").length != 2) {
            hideLoader();
            WarningMessage("Enter Geo Location in proper format");
            return;
        } else if (onClickRuleData.RuleType && onClickRuleData.RuleType.Geo_Location && onClickRuleData.RuleType.Geo_Location.trim().split(" ").length === 2) {
            onClickRuleData.RuleType["Geo_Location_Original"] = {
                longitude_Maxm: parseFloat(onClickRuleData.RuleType.Geo_Location.split(" ")[1]) + parseFloat(onClickRuleData.RuleType.Deviation ? parseFloat(onClickRuleData.RuleType.Deviation) * 0.0166667 : 0.0333333),
                longitude_Minm: parseFloat(onClickRuleData.RuleType.Geo_Location.split(" ")[1]) - parseFloat(onClickRuleData.RuleType.Deviation ? parseFloat(onClickRuleData.RuleType.Deviation) * 0.0166667 : 0.0333333),
                latitude_Minm: parseFloat(onClickRuleData.RuleType.Geo_Location.split(" ")[0]) - parseFloat(onClickRuleData.RuleType.Deviation ? parseFloat(onClickRuleData.RuleType.Deviation) * 0.0166667 : 0.0333333),
                latitude_Maxm: parseFloat(onClickRuleData.RuleType.Geo_Location.split(" ")[0]) + parseFloat(onClickRuleData.RuleType.Deviation ? parseFloat(onClickRuleData.RuleType.Deviation) * 0.0166667 : 0.0333333),
            }
        }
        const res = await httpService.CreateUpdate("getruleapi", data)
            .catch((err) => {
                return;
            });
        if (res.data.ack === '1') {
            hideLoader();
            SuccessMessage(res.data.message)
        } else if (res.data.ack === '2') {
            WarningMessage(res.data.message)
            hideLoader();
        } else if (res.data.ack === '3') {
            WarningMessage(res.data.message)
            hideLoader();
        } else {
            WarningMessage("Something went wrong!")
            hideLoader();
        }
        setShow(false);
        // loadAlldata();
        hideLoader();
        setSelectedRuleValues([]);
        setDefaultVal([]);
        setIPFormatV([]);
        setIPFormatVal([]);
    };

    const setIPvalue = (e, IPFormatData) => {
        if (IPFormatData == "SingleIpAddress") {
            let data = commonUtiles.IPValidation(e.target.value)
            if (data) {
                return
            }
        } else if (IPFormatData == "IpAddressRange") {
            if (commonUtiles.IPValidationForRange(e.target.value)) {
                return
            }
        } else if (IPFormatData == "CIDR") {
            if (commonUtiles.IPValidationWithCIDR(e.target.value)) {
                return
            }
        }
        let ChannelData = { ...onClickRuleData };
        ChannelData.RuleType["IpAddress"] = {};
        ChannelData.RuleType["IpAddress"][IPFormatData] = e.target.value;
        setOnclickRuleData(ChannelData);
        setIPFormatVal(e.target.value)
    }

    const onInputRuleChange = (e) => {
        let value1 = e.target.value
        const validValue = value1.replace(/[^a-zA-Z0-9 ]/g, '');
        setSelectedValue(validValue);

        setOnclickRuleData({ ...onClickRuleData, [e.target.name]: validValue });
        console.log("On Click rule data : ", onClickRuleData)
    };

    const addClickHandler2 = (e) => {

        setDefaultVal([]);
        setOnClickAddAndEditMsg("Add")
        setIPFormatDataValue([]);
        setIPFormatV([]);
        setIPFormatVal([])
        setOnclickRuleData({
            ChannelRulesName: "",
            RuleType: {},
            //   UserId: e._id
        });
        setSave1(true);
    };

    const IPformatFun = (e) => {
        let ChannelData = { ...onClickRuleData };
        ChannelData.RuleType["IpAddress"] = {};
        { IPFormatVal ? ChannelData.RuleType["IpAddress"][e.target.value] = IPFormatVal : ChannelData.RuleType["IpAddress"][e.target.value] = ""; }      // setOnclickRuleData(ChannelData); 
        setIPFormatData(e.target.value);
        setIPFormatV(e.target.value);
        if (e.target.value === "SingleIpAddress") {
            setIpAddressPlaceHolder('255.255.255.0')
            setIpAddressNote('')
        } else if (e.target.value === "IpAddressRange") {
            setIpAddressPlaceHolder('255.255.255.0-255.255.255.255')
            setIpAddressNote("i.e please enter XXX.XXX.XXX.XXX<->XXX.XXX.XXX.XXX")
        } else if (e.target.value === "CIDR") {
            setIpAddressPlaceHolder('255.255.255.0/XX')
            setIpAddressNote("i.e please enter XXX.XXX.XXX.XXX/XX")
        }
    }

    useEffect(() => {
        if (user) {
            checkActiveStatus()
        }
    }, [user, checkActiveStatus])

    useEffect(() => {
        const customerID = localStorage.getItem("customerId");
        const type = localStorage.getItem("CloudUserType");
        if (customerID === 'Admin' || type === "admin") {
            history.push("/admindashboard");
        }
    }, [])
    return (
        <div className="form-boxdiv">
            {loading ? <Loader /> : null}
            <div className="row form-boxtopline5 ">
                <div
                    className="col-9"
                    style={{ display: "flex", gap: "10px", alignItems: "center" }}
                >
                    <div
                        onClick={() => {
                            history.push("/clouddashboard");
                        }}
                    >
                        <Button className="back-btn">
                            <i class="fa fa-chevron-left" aria-hidden="true"></i>
                        </Button>
                    </div>
                    <div>CHANNEL ACCESS PERMISSIONS</div>
                </div>
                <div className="col-3 ">
                    <button
                        className="  btn btn-primary btn-sm"
                        style={{ float: "right" }}
                        onClick={() => {
                            setShow(!show)
                            addClickHandler2()
                        }}
                    >
                        Add Permission
                    </button>
                </div>
            </div>
            <div className="p-3 channel-per">
                <div
                    className="ag-theme-alpine"
                    style={{ height: "calc(70vh - 150px)" }}
                >
                    <AgGridReact
                        pagination={true}
                        paginationPageSize={20}
                        columnDefs={columns}
                        defaultColDef={defaultColDef}
                        enableBrowserTooltips={true}
                        tooltipShowDelay={{ tooltipShowDelay: 0 }}
                        rowData={allRuledata}
                        gridOptions={gridOptions}
                        gridReady={onGridReady}
                        tooltipHideDelay={{ tooltipHideDelay: 100 }}
                    ></AgGridReact>
                </div>
            </div>

            <Modal isOpen={show} toggle={handleClose}>
                <ModalHeader className="model-header-text" toggle={handleClose} >
                    {onClickAddAndEditMsg} Access Permissions
                    <div class="row">
                        <div className="col-12 model-note1">
                            {" "}
                            Note: Only applicable two factor combinations are:
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-4 model-note1">
                            <span className="model-note-icon1">1</span>. Account+GEO
                        </div>
                        <div class="col-4 model-note1 text-center">
                            <span className="model-note-icon1">2</span>. IP+GEO{" "}
                        </div>
                        <div class="col-4 model-note1">
                            <span className="model-note-icon1">3</span>. MAC+GEO
                        </div>
                    </div>
                </ModalHeader>
                <div className="ui main">
                    <form className="ui form">
                        <div className="field">
                            <label>
                                Channel Permission Name<i style={{ color: "red" }}>*</i>
                            </label>
                            <input
                                type="text"
                                name="ChannelRulesName"
                                placeholder="Channel Rules Name "
                                maxLength="20"
                                onChange={(e) => onInputRuleChange(e)}
                                value={onClickRuleData.ChannelRulesName}
                            />
                        </div>
                        <div
                            className="field"
                            style={{ padding: "10px", border: "1px solid #53535369" }}
                        >
                            <label>
                                Permission Type <i style={{ color: "red" }}>*</i>
                            </label>
                            <Select
                                isMulti
                                name="colors"
                                options={ruleSelectValues}
                                value={defaultVal}
                                onChange={handleRuleSelect}
                                className="basic-multi-select"
                                classNamePrefix="select"
                            />
                            {onClickRuleData.RuleType && selectedRuleValues.length > 0
                                ? selectedRuleValues.map((elm, index) => {
                                    return (
                                        <>
                                            {" "}
                                            {elm.value != "Deviation" &&
                                                elm.value != "Geo_Location_Original" ? (
                                                <div>
                                                    <label
                                                        style={{ marginRight: "3px", fontWeight: "bold" }}
                                                    >
                                                        {elm.value === "Geo_Location"
                                                            ? "Geo Location"
                                                            : elm.label}
                                                    </label>
                                                    {elm.value === "Geo_Location" && (
                                                        <span className="text-secondary ml-2">
                                                            {elm.value == "Geo_Location" &&
                                                                "i.e please enter <Lat><space><Long>"}
                                                        </span>
                                                    )}
                                                    {elm.value === "IpAddress" && (
                                                        <span className="text-secondary ml-2">
                                                            {" "}
                                                            {ipAddressNote}
                                                        </span>
                                                    )}
                                                    {elm.value === "IpAddress" ? (
                                                        <div className="row">
                                                            <div className="col-4">
                                                                <select
                                                                    className="form-control"
                                                                    name="IpFormat"
                                                                    onChange={(event) => IPformatFun(event)}
                                                                    value={IPFormatV ? IPFormatV : ""}
                                                                >
                                                                    <option hidden>Select IP Format</option>
                                                                    <option value="SingleIpAddress">
                                                                        Single IP address
                                                                    </option>
                                                                    <option value="IpAddressRange">
                                                                        {" "}
                                                                        IP address range
                                                                    </option>
                                                                    <option value="CIDR">CIDR </option>
                                                                </select>
                                                            </div>
                                                            {onClickRuleData.RuleType &&
                                                                onClickRuleData.RuleType.IpAddress ? (
                                                                <div className="col-8">
                                                                    <input
                                                                        type="text"
                                                                        className=""
                                                                        style={{
                                                                            marginLeft: "5px",
                                                                            paddingRight: "5px",
                                                                        }}
                                                                        onChange={(event) => {
                                                                            setIPvalue(event, IPFormatV);
                                                                        }}
                                                                        placeholder={ipAddressPlaceHolder}
                                                                        value={IPFormatVal ? IPFormatVal : ""}
                                                                    ></input>{" "}
                                                                </div>
                                                            ) : (
                                                                ""
                                                            )}
                                                        </div>
                                                    ) : (
                                                        <input
                                                            type="text"
                                                            style={{ marginTop: "3px" }}
                                                            name={elm.value}
                                                            value={
                                                                onClickRuleData.RuleType[elm.value]
                                                                    ? onClickRuleData.RuleType[elm.value]
                                                                    : ""
                                                            }
                                                            placeholder={elm.label === "Mac Address" ? elm.label + " XX:XX:XX:XX:XX:XX" : elm.label}
                                                            onChange={(event) => {
                                                                handlec2(event);
                                                            }}
                                                            readOnly={elm.value === "AccountNumber" ? true : false}
                                                        ></input>
                                                    )}
                                                </div>
                                            ) : (
                                                ""
                                            )}
                                            {elm.value === "Geo_Location" ? (
                                                <div>
                                                    <label
                                                        style={{ marginRight: "3px", fontWeight: "bold" }}
                                                    >
                                                        Deviation (in mins)
                                                    </label>
                                                    <input
                                                        type="text"
                                                        style={{ marginTop: "3px", marginBottom: "5px" }}
                                                        name="Deviation"
                                                        value={
                                                            onClickRuleData.RuleType
                                                                ? onClickRuleData.RuleType["Deviation"]
                                                                    ? onClickRuleData.RuleType["Deviation"]
                                                                    : ""
                                                                : ""
                                                        }
                                                        placeholder={"Deviation"}
                                                        onChange={(event) => {
                                                            handlec2(event);
                                                        }}
                                                        readOnly={elm.value === "AccountNumber" ? true : false}
                                                    ></input>
                                                </div>
                                            ) : (
                                                ""
                                            )}
                                        </>
                                    );
                                })
                                : ""}
                        </div>
                    </form>
                </div>
                <ModalFooter>
                    <Button
                        color="success"
                        onClick={() => {
                            if (save1) {
                                saveChannelRule();
                            } else {
                                UpdateChannelrule();
                            }
                        }}
                    >
                        {save1 ? "Save" : "Update"}
                    </Button>
                    <Button
                        color="danger"
                        onClick={() => {
                            setShow(false);
                            setOnclickRuleData({});
                            setSelectedRuleValues([]);
                            setDefaultVal([]);
                            setIPFormatV([]);
                            setIPFormatVal([]);
                            getRules()
                        }}
                    >
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default RuleDashboard;
